import { FC, ReactNode } from 'react'

import { useNavigate } from 'react-router-dom'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { Header } from 'shared/ui/header'
import { Skeleton } from 'shared/ui/skeleton'

import s from './styles.module.scss'

interface Props {
  title?: string
  onGoBack?: () => void
  actionRight?: ReactNode
  children?: ReactNode
  backgroundColor?: string
  arrowColor?: string
  isFixed?: boolean
  variant?: 'grey' | 'white' | 'transparent'
  buttonWhite?: boolean
  isLoading?: boolean
}

export const HeaderGoBack: FC<Props> = ({
  title,
  actionRight,
  children,
  isFixed,
  onGoBack,
  backgroundColor,
  arrowColor,
  variant,
  buttonWhite = false,
  isLoading = false,
}) => {
  const navigate = useNavigate()

  const goBack = () => {
    if (onGoBack) {
      onGoBack?.()

      return
    }

    navigate(-1)
  }

  const button = buttonWhite ? (
    <span className={s.whiteBtn}>
      <AppIcon
        onClick={goBack}
        className={s.icon}
        id={AllIcons.ARROW_LEFT}
        color={arrowColor}
        width={24}
        height={24}
      />
    </span>
  ) : (
    <AppIcon
      onClick={goBack}
      className={s.icon}
      id={AllIcons.ARROW_LEFT}
      color={arrowColor}
      width={24}
      height={24}
    />
  )

  return (
    <div className={s.header}>
      <Header
        title={title}
        isFixed={isFixed}
        backgroundColor={backgroundColor}
        variant={variant}
        actionLeft={button}
        actionRight={actionRight}
      >
        {isLoading ? <Skeleton className={s.titleSkeleton} /> : children}
      </Header>
    </div>
  )
}
